export default __webpack_public_path__ + "static/media/gripe-support.32268518.png";